import React, { Component } from "react";
import draw from "./helper.js";

export default class HTimelineVis extends Component {
  componentDidMount() {
    console.log("In component did mount");
    draw(this.props);
  }
  componentDidUpdate(prevProps) {
    console.log("In component did update");
    draw(this.props);
  }
  render() {
    return <div className="timeline-vis"></div>;
  }
}
